export interface StarterPrompt {
  id: string
  title: string
  prompt: string
}

/**
 * Real, analyst-grade investigation shortcuts. These are inserted verbatim
 * into the live agent conversation — no client-side canned responses.
 */
export const starterPrompts: StarterPrompt[] = [
  {
    id: 'investigate-incident',
    title: 'Investighează incidentul 9',
    prompt: 'Investighează incidentul 9',
  },
  {
    id: 'identity-risk',
    title: 'Analizează riscul identității nicolae.iorga@ministerulfericirii.cloud',
    prompt: 'Analizează riscul identității nicolae.iorga@ministerulfericirii.cloud',
  },
  {
    id: 'investigate-endpoint',
    title: 'Investighează mfib-w11-test01',
    prompt: 'Investighează mfib-w11-test01',
  },
  {
    id: 'attack-path',
    title: 'Reconstruiește cel mai probabil attack path pentru incidentul 9',
    prompt: 'Reconstruiește cel mai probabil attack path pentru incidentul 9',
  },
  {
    id: 'evidence-gaps',
    title: 'Ce informații ne lipsesc pentru a determina scope-ul incidentului 9?',
    prompt: 'Ce informații ne lipsesc pentru a determina scope-ul incidentului 9?',
  },
]
